import RolePage from './role.react';
import RoleFormPage from './role-form.react';

export const roleSettings = [
  {
    type: 'ERP',
    modules: [
      {
        name: 'Request',
        key: 'request',
        actions: ['Admin', 'Create', 'Read', 'Update', 'Delete', 'Intranet'],
      },
      {
        name: 'Users',
        key: 'user',
        actions: ['Create', 'Read', 'Update', 'Delete', 'Intranet'],
      },
      // { name: 'Departments', key: 'department', actions: ['Create', 'Read', 'Update', 'Delete'] },
      {
        name: 'Roles',
        key: 'role',
        actions: ['Create', 'Read', 'Update', 'Delete', 'Intranet'],
      },
    ],
  },
  {
    type: 'IMS',
    modules: [
      {
        name: 'Companies',
        key: 'company',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Items',
        key: 'item',
        actions: ['Admin', 'Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Quotations',
        key: 'quotation',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Purchases',
        key: 'purchase',
        actions: ['Admin', 'Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'UI - Undertakes',
        key: 'undertake',
        actions: ['Admin', 'Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'DO / Servicing / Return Stock',
        key: 'adjustment',
        actions: ['Admin', 'Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Roles',
        key: 'role',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Users',
        key: 'user',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Classes',
        key: 'class',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'SubClasses',
        key: 'subclass',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Categories',
        key: 'category',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'OPS',
    modules: [
      {
        name: 'N Park Items',
        key: 'nparkitem',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Officers',
        key: 'officer',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Projects',
        key: 'project',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Work Orders',
        key: 'workorder',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Jobs',
        key: 'job',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Job Orders',
        key: 'joborder',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Locations',
        key: 'location',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Grn',
        key: 'grn',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'ESYS',
    modules: [
      {
        name: 'Flag',
        key: 'flag',
        actions: [
          'ViewerFlag',
          'AdminFlag',
          'ApprovalFlag',
          'TemplateFlag',
          'PayrollSettingFlag',
          'PayrollFlag',
          'PayrollSalaryFlag',
        ],
      },
      {
        name: 'Payroll',
        key: 'payroll',
        actions: ['Create', 'Read', 'Update', 'Delete', 'Admin'],
      },
      {
        name: 'Working Hours',
        key: 'workingHours',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Salary',
        key: 'salary',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Leave Policy',
        key: 'leavePolicy',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'SIGN',
    modules: [
      {
        name: 'Users',
        key: 'users',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'ELeaveApproval',
        key: 'eleaveapproval',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Files',
        key: 'files',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Supervisor',
        key: 'supervisor',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Payment',
        key: 'payment',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Safe Entry',
        key: 'safeentry',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Safe Entry Approval',
        key: 'safeentryapproval',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Sign Department',
        key: 'SignDepartment',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'PAYROLL',
    modules: [
      {
        name: 'Payroll',
        key: 'payroll',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      { name: 'Payslip', key: 'payslip', actions: ['Admin', 'Read'] },
      { name: 'CPF Report', key: 'cpf', actions: ['Read'] },
      { name: 'Bank Report', key: 'bank', actions: ['Read'] },
    ],
  },
  {
    type: 'TMS',
    modules: [
      {
        name: 'Time Sheets',
        key: 'timesheets',
        actions: ['Create', 'Read', 'Update', 'Delete', 'Upload'],
      },
      { name: 'Reports', key: 'reports', actions: ['Read'] },
      {
        name: 'Finger Scan',
        key: 'fingerScan',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'TS',
    modules: [
      {
        name: 'Flag',
        key: 'flag',
        actions: [
          'AdminFlag',
          'HeadAccountFlag',
          'AccountFlag',
          'OperationFlag',
        ],
      },
    ],
  },
  {
    type: 'DORM',
    modules: [
      {
        name: 'Setting',
        key: 'setting',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Company',
        key: 'company',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Resident',
        key: 'resident',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Doc',
        key: 'doc',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        name: 'Floor Plan',
        key: 'floorplan',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
  {
    type: 'FARM',
    modules: [
      {
        name: 'Setting',
        key: 'setting',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ],
  },
];

export { RolePage, RoleFormPage };



// WEBPACK FOOTER //
// ./src/role/index.js